<template>
  <v-content style="height: 100%">
    <hide-at breakpoint="mediumAndBelow">
      <div class="md-layout" style="height: 100%">
        <div
          v-bind:class="[isActive ? 'landingContainerL' : 'landingContainerLC']"
          class="
            ma-0
            pa-0
            md-layout-item md-medium-size-40 md-xsmall-size-40 md-size-40
          "
        >
          <div class="ma-0 pa-0 ml-15">
            <div class="ma-0 pa-0 ml-10">
              <v-row class="ma-0 pa-0 mt-15" style="margin-top: 7em">
                <p
                  v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                  style="font-family: Raleway; font-size: 3vw; font-weight: 300"
                >
                  You're just one click
                </p>
              </v-row>
              <v-row class="ma-0 pa-0 mt-n9">
                <p
                  v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                  style="font-family: Raleway; font-size: 3vw; font-weight: 300"
                >
                  away from the future
                </p>
              </v-row>
            </div>
            <v-row class="ma-0 pa-0 mt-5 ml-10">
              <div style="display: flex">
                <v-menu
                  v-model="sign_up_div"
                  transition="slide-y-transition"
                  bottom
                  offset-y
                  :close-on-content-click="false"
                  :content-class="
                    isActive ? 'my-menu-signupD' : 'my-menu-signupL'
                  "
                  max-width="490"
                >
                  <!-- width="250" -->
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      text
                      large
                      color="white"
                      class="signup_button"
                      style="
                        font-size: 20px;
                        font-family: Nunito Sans;
                        border-radius: 7px;
                        min-width: 13.9vw;
                        max-width: 16vw;
                        height: 5.5vh;
                        font-weight: 660;
                      "
                      >sign up</v-btn
                    >
                  </template>
                  <v-card
                    :style="{
                      background: $vuetify.theme.themes[theme].background,
                    }"
                    elevation="0"
                    style="border-radius: 12px"
                    width="490"
                    height="438"
                    class="ma-0 pa-0"
                  >
                    <p
                      class="pt-3"
                      style="
                        font-family: Nunito Sans;
                        font-size: 20px;
                        font-weight: 500;
                        text-align: center;
                      "
                    >
                      SIGN UP
                    </p>
                    <div style="width: 33em" class="ml-3 mt-n2">
                      <v-text-field
                        v-on:keyup.enter="signupDiv()"
                        v-model="accountName"
                        dense
                        style="border-radius: 8px"
                        outlined
                        label="Name"
                        :rules="[rules.required, rules.minName, rules.maxName]"
                      >
                      </v-text-field>
                    </div>
                    <div style="width: 33em" class="ml-3 mt-n2">
                      <v-text-field
                        dense
                        style="border-radius: 8px"
                        outlined
                        label="Company"
                      >
                      </v-text-field>
                    </div>
                    <div style="width: 33em" class="ml-3 mt-n2">
                      <v-text-field
                        v-on:keyup.enter="signupDiv()"
                        height="45"
                        v-model="accountEmail"
                        dense
                        style="border-radius: 8px"
                        outlined
                        label="Email"
                        :rules="[rules.required, rules.email]"
                      >
                      </v-text-field>
                    </div>
                    <div style="width: 33em" class="ml-3 mt-n2">
                      <v-text-field
                        v-on:keyup.enter="signupDiv()"
                        v-model="accountPassword"
                        dense
                        style="border-radius: 8px"
                        outlined
                        label="Password"
                        :append-icon="showEye ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showEye = !showEye"
                        :type="showEye ? 'text' : 'password'"
                        :rules="[rules.required, rules.minPass, rules.maxPass]"
                      >
                      </v-text-field>
                    </div>
                    <div style="width: 33em" class="ml-3 mt-n2">
                      <v-text-field
                        v-on:keyup.enter="signupDiv()"
                        v-model="accountPasswordConfirm"
                        dense
                        style="border-radius: 8px"
                        outlined
                        label="Password Confirm"
                        :append-icon="showEye ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showEye = !showEye"
                        :type="showEye ? 'text' : 'password'"
                        :rules="[rules.required, rules.minPass, rules.maxPass]"
                      >
                      </v-text-field>
                    </div>
                    <div class="ma-0 pa-0" style="display: flex">
                      <div class="ma-0 pa-0">
                        <p
                          style="
                            font-family: Nunito Sans;
                            margin-left: 1em;
                            margin-top: -0.8em;
                          "
                        >
                          or sign up with
                        </p>
                      </div>
                      <v-spacer></v-spacer>
                      <div class="ma-0 pa-0">
                        <p
                          style="
                            font-size: 11px;
                            color: red;
                            margin-right: 1.5em;
                            margin-top: -0.8em;
                          "
                          v-if="error"
                        >
                          {{ errorMsg }}
                        </p>
                      </div>
                    </div>

                    <div style="display: flex" class="mt-n8 ml-3">
                      <div class="ma-0 pa-0 mt-8">
                        <v-btn
                          v-for="(item, index) in localitem"
                          @click="socialSignup(item)"
                          :key="index"
                          icon
                          class="mr-8"
                          elevation="15"
                        >
                          <md-icon
                            class="md-size-2x"
                            :md-src="item.icon"
                          ></md-icon>
                        </v-btn>
                      </div>

                      <v-spacer></v-spacer>
                      <v-btn
                        class="mt-6 mr-4"
                        text
                        elevation="2"
                        x-large
                        color="white"
                        style="
                          font-size: 15px;
                          font-family: Nunito Sans;
                          background-color: #419cff;
                          border-radius: 10px;
                          width: 10em;
                          font-weight: 660;
                        "
                        @click="signupDiv()"
                        >sign up</v-btn
                      >
                    </div>
                  </v-card>
                </v-menu>

                <v-menu
                  v-model="log_in_div"
                  class="mb-3"
                  transition="slide-y-transition"
                  bottom
                  left
                  :close-on-content-click="false"
                  :content-class="
                    isActive ? 'my-menu-loginD' : 'my-menu-loginL'
                  "
                  max-width="490"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      color="black"
                      class="ml-4 login_button"
                      text
                      large
                      style="
                        font-size: 20px;
                        font-family: Nunito Sans;
                        background-color: white;
                        border-radius: 7px;
                        min-width: 13.9vw;
                        max-width: 16vw;
                        height: 5.5vh;
                        font-weight: 900;
                      "
                      >login</v-btn
                    >
                  </template>
                  <v-card
                    :style="{
                      background: $vuetify.theme.themes[theme].background,
                    }"
                    elevation="0"
                    style="border-radius: 12px"
                    width="490"
                    height="420"
                    class="ma-0 pa-0"
                  >
                    <p
                      class="pt-3"
                      style="
                        font-family: Nunito Sans;
                        font-size: 20px;
                        font-weight: 500;
                        text-align: center;
                      "
                    >
                      LOG IN
                    </p>
                    <div style="width: 33em" class="ml-3 mt-n1">
                      <v-text-field
                        v-on:keyup.enter="loginDiv()"
                        v-model="accountName"
                        dense
                        style="border-radius: 8px"
                        outlined
                        label="Name"
                        :rules="[rules.required, rules.minName, rules.maxName]"
                      >
                      </v-text-field>
                    </div>
                    <div style="width: 33em" class="ml-3 mt-n1">
                      <v-text-field
                        dense
                        style="border-radius: 8px"
                        outlined
                        label="Company"
                      >
                      </v-text-field>
                    </div>
                    <div style="width: 33em" class="ml-3 mt-n1">
                      <v-text-field
                        v-on:keyup.enter="loginDiv()"
                        v-model="accountEmail"
                        dense
                        style="border-radius: 8px"
                        outlined
                        label="Email"
                        :rules="[rules.required, rules.email]"
                      >
                      </v-text-field>
                    </div>
                    <div style="width: 33em" class="ml-3 mt-n1">
                      <v-text-field
                        v-on:keyup.enter="loginDiv()"
                        v-model="accountPassword"
                        dense
                        style="border-radius: 8px"
                        outlined
                        label="Password"
                        :append-icon="showEye ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showEye = !showEye"
                        :type="showEye ? 'text' : 'password'"
                        :rules="[rules.required, rules.minPass, rules.maxPass]"
                      >
                      </v-text-field>
                    </div>
                    <div class="ma-0 pa-0 mt-n1" style="display: flex">
                      <v-spacer></v-spacer>
                      <div class="ma-0 pa-0">
                        <p
                          style="
                            font-family: Nunito Sans;
                            margin-right: 1.5em;
                            cursor: pointer;
                          "
                          @click="sendPasswordResetEmail()"
                        >
                          forgot your password?
                        </p>
                      </div>
                    </div>
                    <div class="ma-0 pa-0 mt-n3" style="display: flex">
                      <div class="ma-0 pa-0">
                        <p style="font-family: Nunito Sans; margin-left: 1em">
                          or log in with
                        </p>
                      </div>
                      <v-spacer></v-spacer>
                      <div class="ma-0 pa-0">
                        <p
                          style="
                            font-size: 11px;
                            color: red;
                            margin-right: 1.5em;
                          "
                          v-if="error"
                        >
                          {{ errorMsg }}
                        </p>
                      </div>
                    </div>

                    <div style="display: flex" class="mt-n8 ml-3">
                      <div class="ma-0 pa-0 mt-8">
                        <v-btn
                          v-for="(item, index) in localitem"
                          @click="socialSignup(item)"
                          :key="index"
                          icon
                          class="mr-8"
                          elevation="15"
                        >
                          <md-icon
                            class="md-size-2x"
                            :md-src="item.icon"
                          ></md-icon>
                        </v-btn>
                      </div>

                      <v-spacer></v-spacer>
                      <v-btn
                        class="mt-6 mr-4"
                        text
                        elevation="2"
                        x-large
                        color="white"
                        style="
                          font-size: 15px;
                          font-family: Nunito Sans;
                          background-color: #419cff;
                          border-radius: 10px;
                          width: 10em;
                          font-weight: 660;
                        "
                        @click="loginDiv()"
                        >log in</v-btn
                      >
                    </div>
                  </v-card>
                </v-menu>
              </div>
            </v-row>
            <div class="ma-0 pa-0 mt-6 ml-10">
              <div
                class="mr-15"
                v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                style="font-family: Nunito Sans; display: flex"
              >
                <div class="ma-0 pa-0">
                  <p>or sign up with</p>
                </div>
              </div>
            </div>
            <v-row class="ma-0 pa-0 mt-n8 ml-11">
              <div style="display: flex" class="mt-9">
                <v-btn
                  v-for="(item, index) in localitem"
                  @click="socialSignup(item)"
                  :key="index"
                  icon
                  class="mr-8"
                  elevation="15"
                >
                  <md-icon class="md-size-2x" :md-src="item.icon"></md-icon>
                </v-btn>
              </div>
            </v-row>

            <div
              class="ma-0 pa-0 ml-15"
              style="position: absolute; bottom: 3.5em; left: 0"
            >
              <v-row class="ma-0 pa-0 ml-10">
                <v-btn
                  color="black"
                  class="login_button"
                  text
                  large
                  style="
                    font-size: 20px;
                    font-family: Nunito Sans;
                    color: #000000;
                    background-color: white;
                    border-radius: 7px;
                    min-width: 13vw;
                    max-width: 16vw;
                    height: 5.5vh;
                    font-weight: 900;
                  "
                  @click="goToWeltfernSite()"
                  >request demo</v-btn
                >
              </v-row>
              <v-row class="ma-0 pa-0 ml-10 mt-6">
                <v-list color="transparent">
                  <p
                    v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                    style="font-family: Nunito Sans; font-weight: 600"
                  >
                    No license yet?
                  </p>
                  <div style="display: flex" class="mt-n4">
                    <p
                      v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                      style="font-family: Nunito Sans"
                      class="mr-1"
                    >
                      Click
                    </p>
                    <a
                      style="font-family: Nunito Sans; color: #419cff"
                      class="mr-1"
                      target="_blank"
                      href="https://www.weltfern.com/augmentable"
                    >
                      here
                    </a>
                    <p
                      v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                      style="font-family: Nunito Sans"
                    >
                      to go to augmentable page.
                    </p>
                  </div>
                  <p
                    v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                    style="font-family: Nunito Sans"
                    class="mt-n4"
                  >
                    Info and questions are welcome to
                  </p>
                  <p
                    v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                    style="font-weight: 600; font-family: Nunito Sans"
                    class="mt-n4"
                  >
                    info@augmentable.online
                  </p>
                </v-list>
              </v-row>
            </div>
          </div>
        </div>
        <div
          v-bind:class="[isActive ? 'landingContainerR' : 'landingContainerRC']"
          class="
            ma-0
            pa-0
            md-layout-item md-medium-size-60 md-xsmall-size-60 md-size-60
          "
          @contextmenu.prevent
        >
          <!--  autoplay loop  -->
          <!-- <audio controls autoplay hidden id="sound">
            <source :src="fileAsset.filesound" type="audio/ogg" />
          </audio> -->
          <model-viewer
            style="width: 100%; height: 100%; min-height: 100vh; z-index: 1000"
            :src="fileAsset.fileee"
            :ios-src="fileAsset.fileusdz"
            :poster="fileAsset.filepng"
            :environment-image="fileAsset.filehdr"
            id="loading-demo-sub"
            reveal="interaction"
            camera-controls
            shadow-intensity="3"
            exposure="1.5"
            ar
            autoplay
            ar-modes="webxr scene-viewer quick-look"
            ar-scale="auto"
            alt="A 3D model of an astronaut"
          >
            <!-- <div class="progress-bar" slot="progress-bar">
              <div class="update-bar"></div>
            </div> -->
          </model-viewer>
          <div style="position: absolute; top: 4%; left: 43%; z-index: 2000">
            <div class="ma-0 pa-0" style="display: flex">
              <p
                @click="changetheme()"
                v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                style="
                  cursor: pointer;
                  font-family: Raleway;
                  font-size: 36px;
                  font-weight: 700;
                "
              >
                augmentable
              </p>
              <p class="mt-3 ml-2" style="color: #419cff">beta 1.19</p>
            </div>
          </div>
          <div style="position: absolute; top: 4%; right: 2%; z-index: 2000">
            <v-btn
              outlined
              x-large
              v-bind:color="isActive ? '#CFCFCF' : '#323232'"
              style="
                font-family: Nunito Sans;
                background-color: transparent;
                border-radius: 10px;
                font-weight: 700;
                font-size: 20px;
              "
              >view in ar</v-btn
            >
          </div>
          <div
            style="
              position: absolute;
              bottom: 4%;
              left: 44%;
              width: 50em;
              z-index: 100;
            "
          >
            <p
              v-bind:class="[isActive ? 'textureL' : 'textureLC']"
              style="
                font-family: Nunito Sans;
                font-size: 36px;
                font-weight: 200;
                opacity: 0.8;
              "
            >
              {{ quotation }}
            </p>
            <p
              v-bind:class="[isActive ? 'textureL' : 'textureLC']"
              style="
                font-family: Nunito Sans;
                font-size: 21px;
                font-weight: 600;
              "
              class="mt-n2"
            >
              {{ author }}
            </p>
          </div>
        </div>
      </div>
    </hide-at>
    <show-at breakpoint="mediumAndBelow">
      <div class="ma-0 pa-0">
        <hide-at breakpoint="small">
          <div class="md-layout" style="height: 100%">
            <div
              v-bind:class="[
                isActive ? 'landingContainerR' : 'landingContainerRC',
              ]"
              style="height: 56vh"
              class="
                ma-0
                pa-0
                md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100
              "
              @contextmenu.prevent
            >
              <model-viewer
                style="
                  width: 100%;
                  height: 100%;
                  min-height: 50vh;
                  z-index: 1000;
                "
                :src="fileAsset.fileee"
                :ios-src="fileAsset.fileusdz"
                :poster="fileAsset.filepng"
                :environment-image="fileAsset.filehdr"
                id="loading-demo-sub"
                camera-controls
                shadow-intensity="3"
                ar
                ar-modes="webxr scene-viewer quick-look"
                ar-scale="auto"
                alt="A 3D model of an astronaut"
              >
                <button
                  slot="ar-button"
                  style="
                    position: absolute;
                    bottom: 2vw;
                    left: 10vw;
                    background-color: transparent;
                    color: #e0e0e0;
                    border: 2px solid #e0e0e0;
                    border-radius: 7px;
                    width: 20vw;
                    height: 5vh;
                  "
                >
                  View in AR
                </button>
              </model-viewer>
              <div
                style="position: absolute; top: 3vw; left: 34vw; z-index: 2000"
              >
                <div class="ma-0 pa-0" style="display: flex">
                  <p
                    @click="changetheme()"
                    v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                    style="
                      font-family: Raleway;
                      font-size: 5vw;
                      font-weight: 700;
                    "
                  >
                    augmentable
                  </p>
                  <p class="mt-3 ml-2" style="color: #419cff">beta 1.19</p>
                </div>
              </div>
              <div style="position: absolute; bottom: 61vw; left: 8vw"></div>
              <div
                style="
                  position: absolute;
                  bottom: 58.4vw;
                  left: 38vw;
                  width: 58vw;
                  z-index: 100;
                "
              >
                <p
                  v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                  style="font-family: Nunito Sans; font-size: 2.3vw"
                >
                  {{ quotation }}
                </p>
                <p
                  v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                  style="font-family: Nunito Sans; font-size: 1.7vw"
                  class="mt-n3"
                >
                  {{ author }}
                </p>
              </div>
            </div>
            <div
              v-bind:class="[
                isActive ? 'landingContainerL' : 'landingContainerLC',
              ]"
              style="height: 44vh"
              class="
                ma-0
                pa-0
                md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100
              "
            >
              <p
                class="mt-3"
                v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                style="
                  font-family: Raleway;
                  text-align: center;
                  font-size: 4.6vw;
                  font-weight: 500;
                "
              >
                You're just one click away from the future
              </p>
              <div style="display: flex; margin-left: 5em" class="mt-n2">
                <v-menu
                  transition="slide-y-transition"
                  bottom
                  offset-y
                  v-model="log_in_div"
                  :close-on-content-click="false"
                  :content-class="isActive ? 'tablet-loginD' : 'tablet-loginL'"
                  style="width: 76vw !important"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      color="black"
                      large
                      class="login_button"
                      text
                      style="
                        font-family: Nunito Sans;
                        font-weight: 900;
                        background-color: white;
                        border-radius: 7px;
                        width: 41vw;
                        font-weight: 800;
                      "
                      >login</v-btn
                    >
                  </template>
                  <v-card
                    :style="{
                      background: $vuetify.theme.themes[theme].background,
                    }"
                    elevation="0"
                    class="ma-0 pa-0"
                    style="
                      border-radius: 10px;
                      width: 80vw !important;
                      height: 25.6vh;
                    "
                  >
                    <div style="display: flex" class="pt-1">
                      <div>
                        <div
                          style="width: 47vw; height: 7.3vh; padding-top: 1.8vw"
                          class="ml-3"
                        >
                          <v-text-field
                            v-on:keyup.enter="loginDiv()"
                            v-model="accountName"
                            dense
                            style="border-radius: 8px"
                            outlined
                            label="Name"
                            :rules="[
                              rules.required,
                              rules.minName,
                              rules.maxName,
                            ]"
                          >
                          </v-text-field>
                        </div>
                        <div style="width: 47vw; height: 6vh" class="ml-3">
                          <v-text-field
                            dense
                            style="border-radius: 8px"
                            outlined
                            label="Company"
                          >
                          </v-text-field>
                        </div>
                        <div style="width: 47vw; height: 6vh" class="ml-3">
                          <v-text-field
                            v-on:keyup.enter="loginDiv()"
                            v-model="accountEmail"
                            dense
                            style="border-radius: 8px"
                            outlined
                            label="Email"
                            :rules="[rules.required, rules.email]"
                          >
                          </v-text-field>
                        </div>
                        <div style="width: 47vw; height: 7vh" class="ml-3">
                          <v-text-field
                            v-on:keyup.enter="loginDiv()"
                            v-model="accountPassword"
                            dense
                            style="border-radius: 8px"
                            outlined
                            label="Password"
                            :append-icon="showEye ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="showEye = !showEye"
                            :type="showEye ? 'text' : 'password'"
                            :rules="[
                              rules.required,
                              rules.minPass,
                              rules.maxPass,
                            ]"
                          >
                          </v-text-field>
                        </div>
                      </div>
                      <div style="padding-top: 12vw">
                        <div>
                          <p
                            style="font-size: 11px; color: red"
                            class="ml-4"
                            v-if="error"
                          >
                            {{ errorMsg }}
                          </p>
                        </div>
                        <div class="ml-3 mt-n3">
                          <p
                            style="font-family: Nunito Sans; margin-left: 0.4em"
                          >
                            or log in with
                          </p>
                          <div style="display: flex" class="ml-1">
                            <v-btn
                              v-for="(item, index) in localitem"
                              :key="index"
                              icon
                              width="20"
                              height="20"
                              class="mr-9"
                              elevation="20"
                            >
                              <md-icon
                                class="md-size-1x"
                                :md-src="item.icon"
                              ></md-icon>
                            </v-btn>
                          </div>
                          <div class="ma-0 pa-0 mt-5">
                            <v-btn
                              class="mr-4 login_button"
                              text
                              elevation="2"
                              large
                              color="white"
                              style="
                                font-size: 15px;
                                font-family: Nunito Sans;
                                background-color: #419cff;
                                border-radius: 10px;
                                width: 10em;
                                font-weight: 660;
                              "
                              @click="loginDiv()"
                              >LOG IN</v-btn
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card>
                </v-menu>

                <v-menu
                  v-model="sign_up_div"
                  transition="slide-y-transition"
                  bottom
                  offset-y
                  left
                  :close-on-content-click="false"
                  :content-class="
                    isActive ? 'tablet-signupD' : 'tablet-signupL'
                  "
                  style="width: 92vw !important"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      text
                      color="white"
                      class="ml-7 signup_button"
                      large
                      style="
                        font-family: Nunito Sans;
                        font-weight: 900;
                        border-radius: 7px;
                        width: 41vw;
                      "
                      >sign up</v-btn
                    >
                  </template>
                  <v-card
                    :style="{
                      background: $vuetify.theme.themes[theme].background,
                    }"
                    elevation="0"
                    class="ma-0 pa-0"
                    style="
                      border-radius: 10px;
                      width: 92vw !important;
                      height: 30.9vh;
                    "
                  >
                    <div style="display: flex">
                      <div>
                        <div
                          style="width: 47vw; height: 7vh; padding-top: 1.8vw"
                          class="ml-3"
                        >
                          <v-text-field
                            v-on:keyup.enter="signupDiv()"
                            v-model="accountName"
                            dense
                            style="border-radius: 8px"
                            outlined
                            label="Name"
                            :rules="[
                              rules.required,
                              rules.minName,
                              rules.maxName,
                            ]"
                          >
                          </v-text-field>
                        </div>
                        <div style="width: 47vw; height: 5.3vh" class="ml-3">
                          <v-text-field
                            dense
                            style="border-radius: 8px"
                            outlined
                            label="Company"
                          >
                          </v-text-field>
                        </div>
                        <div style="width: 47vw; height: 6.4vh" class="ml-3">
                          <v-text-field
                            v-on:keyup.enter="signupDiv()"
                            height="45"
                            v-model="accountEmail"
                            dense
                            style="border-radius: 8px"
                            outlined
                            label="Email"
                            :rules="[rules.required, rules.email]"
                          >
                          </v-text-field>
                        </div>
                        <div style="width: 47vw; height: 6.2vh" class="ml-3">
                          <v-text-field
                            v-on:keyup.enter="signupDiv()"
                            v-model="accountPassword"
                            dense
                            style="border-radius: 8px"
                            outlined
                            label="Password"
                            :append-icon="showEye ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="showEye = !showEye"
                            :type="showEye ? 'text' : 'password'"
                            :rules="[
                              rules.required,
                              rules.minPass,
                              rules.maxPass,
                            ]"
                          >
                          </v-text-field>
                        </div>
                        <div style="width: 47vw; height: 6vh" class="ml-3">
                          <v-text-field
                            v-on:keyup.enter="signupDiv()"
                            v-model="accountPasswordConfirm"
                            dense
                            style="border-radius: 8px"
                            outlined
                            label="Password Confirm"
                            :append-icon="showEye ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="showEye = !showEye"
                            :type="showEye ? 'text' : 'password'"
                            :rules="[
                              rules.required,
                              rules.minPass,
                              rules.maxPass,
                            ]"
                          >
                          </v-text-field>
                        </div>
                      </div>
                      <div style="padding-top: 24vw; margin-left: 0.8em">
                        <div>
                          <p
                            style="font-size: 11px; color: red"
                            class="mt-n8"
                            v-if="error"
                          >
                            {{ errorMsg }}
                          </p>
                        </div>
                        <div>
                          <p
                            style="font-family: Nunito Sans; margin-left: 0.2em"
                            class="mt-n3"
                          >
                            or sign up with
                          </p>
                        </div>
                        <div style="display: flex" class="ml-1">
                          <v-btn
                            v-for="(item, index) in localitem"
                            @click="socialSignup(item)"
                            :key="index"
                            icon
                            width="20"
                            height="20"
                            class="mr-9"
                            elevation="20"
                          >
                            <md-icon
                              class="md-size-1x"
                              :md-src="item.icon"
                            ></md-icon>
                          </v-btn>
                        </div>
                        <div class="ma-0 pa-0 mt-5">
                          <v-btn
                            class="mr-4"
                            text
                            elevation="2"
                            large
                            color="white"
                            style="
                              font-size: 15px;
                              font-family: Nunito Sans;
                              background-color: #419cff;
                              border-radius: 10px;
                              width: 11em;
                              font-weight: 660;
                            "
                            @click="signupDiv()"
                            >SIGN UP</v-btn
                          >
                        </div>
                      </div>
                    </div>
                  </v-card>
                </v-menu>
              </div>

              <div style="margin-left: 5em">
                <p
                  v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                  class="mt-3"
                  style="font-family: Nunito Sans; font-size: 2vw"
                >
                  or sign up with
                </p>
              </div>
              <div style="display: flex; margin-left: 5em" class="mt-n2">
                <v-btn
                  v-for="(item, index) in localitem"
                  @click="socialSignup(item)"
                  :key="index"
                  icon
                  width="20"
                  height="20"
                  class="mr-9"
                  elevation="20"
                >
                  <md-icon class="md-size-1x" :md-src="item.icon"></md-icon>
                </v-btn>
              </div>

              <v-list color="transparent" style="margin-left: 5em" class="mt-3">
                <p
                  v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                  style="
                    font-family: Nunito Sans;
                    font-weight: 600;
                    font-size: 2vw;
                  "
                >
                  No license yet?
                </p>
                <div style="display: flex" class="mt-n4">
                  <p
                    v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                    style="font-family: Nunito Sans; font-size: 1.6vw"
                    class="mr-2"
                  >
                    Click
                  </p>
                  <a
                    style="font-family: Nunito Sans; color: #419cff"
                    class="mr-1"
                    target="_blank"
                    href="https://www.weltfern.com/augmentable"
                  >
                    here
                  </a>
                  <p
                    v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                    style="font-family: Nunito Sans; font-size: 1.6vw"
                  >
                    to go to augmentable page.
                  </p>
                </div>
                <p
                  v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                  style="font-family: Nunito Sans; font-size: 1.6vw"
                  class="mt-n4"
                >
                  Info and questions are welcome to
                </p>
                <p
                  v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                  style="
                    font-family: Nunito Sans;
                    font-weight: 600;
                    font-size: 1.6vw;
                  "
                  class="mt-n4"
                >
                  info@augmentable.online
                </p>
              </v-list>
              <v-btn
                color="black"
                large
                class="mt-n2 login_button"
                text
                style="
                  font-family: Nunito Sans;
                  font-weight: 900;
                  background-color: white;
                  border-radius: 7px;
                  width: 41vw;
                  font-weight: 800;
                  margin-left: 5.1em;
                  cursor: pointer;
                "
                @click="goToWeltfernSite()"
                >request demo</v-btn
              >
            </div>
          </div>
        </hide-at>
        <show-at breakpoint="small">
          <div class="md-layout" style="height: 100%">
            <div
              v-bind:class="[
                isActive ? 'landingContainerR' : 'landingContainerRC',
              ]"
              style="height: 55vh"
              class="
                ma-0
                pa-0
                md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100
              "
              @contextmenu.prevent
            >
              <model-viewer
                style="
                  width: 100%;
                  height: 100%;
                  min-height: 50vh;
                  z-index: 1000;
                "
                :src="fileAsset.fileee"
                :ios-src="fileAsset.fileusdz"
                :poster="fileAsset.filepng"
                :environment-image="fileAsset.filehdr"
                id="loading-demo-sub"
                camera-controls
                shadow-intensity="3"
                ar
                ar-modes="webxr scene-viewer quick-look"
                ar-scale="auto"
                alt="A 3D model of an astronaut"
              >
                <button
                  slot="ar-button"
                  style="
                    position: absolute;
                    bottom: 15vw;
                    left: 37.5vw;
                    background-color: transparent;
                    color: #e0e0e0;
                    border: 2px solid #e0e0e0;
                    border-radius: 7px;
                    width: 25vw;
                    height: 3vh;
                  "
                >
                  View in AR
                </button>
              </model-viewer>
              <div
                style="position: absolute; top: 9vw; left: 28vw; z-index: 2000"
              >
                <div class="ma-0 pa-0" style="display: flex">
                  <p
                    @click="changetheme()"
                    v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                    style="
                      font-family: Raleway;
                      font-size: 7vw;
                      font-weight: 700;
                    "
                  >
                    augmentable
                  </p>
                  <p class="mt-3 ml-2" style="color: #419cff">beta 1.19</p>
                </div>
              </div>

              <div
                style="
                  position: absolute;
                  top: 47.5vh;
                  left: 22vw;
                  width: 68vw;
                  z-index: 100;
                "
              >
                <p
                  v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                  style="font-family: Nunito Sans; font-size: 2.5vw"
                >
                  {{ quotation }}
                </p>
                <p
                  v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                  style="font-family: Nunito Sans; font-size: 1.8vw"
                  class="mt-n3"
                >
                  {{ author }}
                </p>
              </div>
            </div>
            <div
              v-bind:class="[
                isActive ? 'landingContainerL' : 'landingContainerLC',
              ]"
              style="height: 45vh"
              class="
                ma-0
                pa-0
                md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100
              "
            >
              <p
                class="mt-5"
                v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                style="
                  font-family: Raleway;
                  text-align: center;
                  font-size: 4.6vw;
                  font-weight: 500;
                "
              >
                You're just one click away from the future
              </p>
              <v-btn
                @click="signupPopupDiv()"
                text
                color="white"
                class="mt-n2 signup_button"
                x-large
                style="
                  font-family: Nunito Sans;
                  font-weight: 900;
                  border-radius: 7px;
                  width: 93vw;
                  margin-left: 3vw;
                "
                >sign up</v-btn
              >
              <v-btn
                text
                v-on="on"
                color="black"
                class="mt-2 login_button"
                x-large
                style="
                  font-family: Nunito Sans;
                  font-weight: 900;
                  background-color: white;
                  border-radius: 7px;
                  width: 93vw;
                  margin-left: 3vw;
                "
                @click="loginPopupDiv()"
                >login</v-btn
              >
              <p
                class="mt-1"
                v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                style="
                  font-family: Nunito Sans;
                  font-size: 3vw;
                  text-align: center;
                "
              >
                or sign up with
              </p>

              <v-row
                justify="center"
                class="
                  ma-0
                  pa-0
                  mt-n3
                  md-layout-item
                  md-medium-size-100
                  md-xsmall-size-100
                  md-size-100
                "
              >
                <div style="display: flex">
                  <v-btn
                    v-for="(item, index) in localitem"
                    @click="socialSignup(item)"
                    :key="index"
                    icon
                    width="20"
                    height="20"
                    class="mr-6"
                    elevation="15"
                  >
                    <md-icon class="md-size-1x" :md-src="item.icon"></md-icon>
                  </v-btn>
                </div>
              </v-row>
              <v-row
                class="
                  ma-0
                  pa-0
                  mt-n6
                  md-layout-item
                  md-medium-size-100
                  md-xsmall-size-100
                  md-size-100
                "
                style=""
              >
                <v-col cols="4">
                  <v-btn
                    text
                    color="black"
                    class="mt-6 login_button"
                    x-large
                    style="
                      font-family: Nunito Sans;
                      font-weight: 900;
                      background-color: white;
                      border-radius: 7px;
                      width: 25vw;
                      margin-left: 3vw;
                    "
                    @click="goToWeltfernSite()"
                    >demo</v-btn
                  >
                </v-col>
                <v-col cols="8" class="mt-3">
                  <v-list color="transparent" style="">
                    <p
                      v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                      style="
                        font-size: 3vw;
                        font-family: Nunito Sans;
                        font-weight: 600;
                      "
                    >
                      No license yet?
                    </p>
                    <div style="display: flex" class="mt-n4">
                      <p
                        v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                        style="font-family: Nunito Sans; font-size: 3vw"
                        class="mr-2"
                      >
                        Click
                      </p>
                      <a
                        style="font-family: Nunito Sans; color: #419cff"
                        class="mr-1"
                        target="_blank"
                        href="https://www.weltfern.com/augmentable"
                      >
                        here
                      </a>
                      <p
                        v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                        style="font-family: Nunito Sans; font-size: 3vw"
                      >
                        to go to augmentable page.
                      </p>
                    </div>
                    <p
                      v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                      style="font-family: Nunito Sans; font-size: 3vw"
                      class="mt-n4"
                    >
                      Info and questions are welcome to
                    </p>
                    <p
                      v-bind:class="[isActive ? 'textureL' : 'textureLC']"
                      style="
                        font-size: 3vw;
                        font-family: Nunito Sans;
                        font-weight: 600;
                      "
                      class="mt-n4"
                    >
                      info@augmentable.online
                    </p>
                  </v-list>
                </v-col>
              </v-row>
            </div>
            <div
              class="overlayContainer"
              v-if="loginPopup"
              @click.self.prevent="loginPopup = !loginPopup"
            >
              <v-card
                :style="{ background: $vuetify.theme.themes[theme].background }"
                elevation="0"
                style="border-radius: 12px; width: 93vw"
                light
                min-height="385"
                class="ma-0 pa-0 overlayElement"
              >
                <p
                  class="pt-4"
                  style="
                    font-family: Nunito Sans;
                    font-size: 20px;
                    font-weight: 500;
                    text-align: center;
                  "
                >
                  LOG IN
                </p>
                <div style="width: 87vw" class="ml-3 mt-n2">
                  <v-text-field
                    v-on:keyup.enter="loginDiv()"
                    v-model="accountName"
                    dense
                    style="border-radius: 8px"
                    outlined
                    label="Name"
                    :rules="[rules.required, rules.minName, rules.maxName]"
                  >
                  </v-text-field>
                </div>
                <div style="width: 87vw" class="ml-3 mt-n1">
                  <v-text-field
                    dense
                    style="border-radius: 8px"
                    outlined
                    label="Company"
                  >
                  </v-text-field>
                </div>
                <div style="width: 87vw" class="ml-3 mt-n1">
                  <v-text-field
                    v-on:keyup.enter="loginDiv()"
                    v-model="accountEmail"
                    dense
                    style="border-radius: 8px"
                    outlined
                    label="Email"
                    :rules="[rules.required, rules.email]"
                  >
                  </v-text-field>
                </div>
                <div style="width: 87vw" class="ml-3 mt-n1">
                  <v-text-field
                    v-on:keyup.enter="loginDiv()"
                    v-model="accountPassword"
                    dense
                    style="border-radius: 8px"
                    outlined
                    label="Password"
                    :append-icon="showEye ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showEye = !showEye"
                    :type="showEye ? 'text' : 'password'"
                    :rules="[rules.required, rules.minPass, rules.maxPass]"
                  >
                  </v-text-field>
                </div>
                <div style="display: flex" class="mt-1">
                  <p
                    style="
                      font-family: Nunito Sans;
                      margin-left: 1em;
                      margin-top: -0.7em;
                    "
                  >
                    or log in with
                  </p>
                  <v-spacer></v-spacer>
                  <p
                    style="
                      font-size: 11px;
                      color: red;
                      margin-top: -0.5em;
                      margin-right: 2em;
                    "
                    class=""
                    v-if="error"
                  >
                    {{ errorMsg }}
                  </p>
                </div>
                <div style="display: flex" class="mt-n8 ml-3">
                  <div class="ma-0 pa-0 mt-8" style="display: flex">
                    <v-btn
                      v-for="(item, index) in localitem"
                      :key="index"
                      icon
                      width="20"
                      height="20"
                      class="mr-7"
                      elevation="20"
                    >
                      <md-icon class="md-size-1x" :md-src="item.icon"></md-icon>
                    </v-btn>
                  </div>

                  <v-spacer></v-spacer>
                  <v-btn
                    class="mt-4 mr-4"
                    text
                    elevation="2"
                    large
                    color="white"
                    style="
                      font-size: 15px;
                      font-family: Nunito Sans;
                      background-color: #419cff;
                      border-radius: 10px;
                      width: 10em;
                      font-weight: 660;
                    "
                    @click="loginDiv()"
                    >LOG IN</v-btn
                  >
                </div>
              </v-card>
            </div>
            <div
              class="overlayContainer"
              v-if="signUpPopup"
              @click.self.prevent="signUpPopup = !signUpPopup"
            >
              <v-card
                :style="{ background: $vuetify.theme.themes[theme].background }"
                elevation="0"
                style="border-radius: 12px; width: 93vw !important"
                min-height="445"
                color=""
                light
                class="ma-0 pa-0 overlayElement"
              >
                <p
                  class="pt-4"
                  style="
                    font-family: Nunito Sans;
                    font-size: 20px;
                    font-weight: 500;
                    text-align: center;
                  "
                >
                  SIGN UP
                </p>
                <div style="width: 86vw !important" class="ml-3 mt-n2">
                  <v-text-field
                    v-on:keyup.enter="signupDiv()"
                    v-model="accountName"
                    dense
                    style="border-radius: 8px"
                    outlined
                    label="Name"
                    :rules="[rules.required, rules.minName, rules.maxName]"
                  >
                  </v-text-field>
                </div>
                <div style="width: 86vw !important" class="ml-3 mt-n1">
                  <v-text-field
                    dense
                    style="border-radius: 8px"
                    outlined
                    label="Company"
                  >
                  </v-text-field>
                </div>
                <div style="width: 86vw !important" class="ml-3 mt-n1">
                  <v-text-field
                    v-on:keyup.enter="signupDiv()"
                    height="45"
                    v-model="accountEmail"
                    dense
                    style="border-radius: 8px"
                    outlined
                    label="Email"
                    :rules="[rules.required, rules.email]"
                  >
                  </v-text-field>
                </div>
                <div style="width: 86vw !important" class="ml-3 mt-n1">
                  <v-text-field
                    v-on:keyup.enter="signupDiv()"
                    v-model="accountPassword"
                    dense
                    style="border-radius: 8px"
                    outlined
                    label="Password"
                    :append-icon="showEye ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showEye = !showEye"
                    :type="showEye ? 'text' : 'password'"
                    :rules="[rules.required, rules.minPass, rules.maxPass]"
                  >
                  </v-text-field>
                </div>
                <div style="width: 86vw !important" class="ml-3 mt-n1">
                  <v-text-field
                    v-on:keyup.enter="signupDiv()"
                    v-model="accountPasswordConfirm"
                    dense
                    style="border-radius: 8px"
                    outlined
                    label="Password Confirm"
                    :append-icon="showEye ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showEye = !showEye"
                    :type="showEye ? 'text' : 'password'"
                    :rules="[rules.required, rules.minPass, rules.maxPass]"
                  >
                  </v-text-field>
                </div>
                <div style="display: flex" class="mt-n3">
                  <p style="font-family: Nunito Sans; margin-left: 1em">
                    or sign up with
                  </p>
                  <v-spacer></v-spacer>
                  <p
                    style="font-size: 11px; color: red"
                    class="mt-1 mr-5"
                    v-if="error"
                  >
                    {{ errorMsg }}
                  </p>
                </div>
                <div style="display: flex" class="mt-n8 ml-3">
                  <div class="ma-0 pa-0 mt-8" style="display: flex">
                    <v-btn
                      v-for="(item, index) in localitem"
                      @click="socialSignup(item)"
                      :key="index"
                      icon
                      width="20"
                      height="20"
                      class="mr-7"
                      elevation="20"
                    >
                      <md-icon class="md-size-1x" :md-src="item.icon"></md-icon>
                    </v-btn>
                  </div>

                  <v-spacer></v-spacer>
                  <v-btn
                    class="mt-4 mr-4"
                    text
                    elevation="2"
                    large
                    color="white"
                    style="
                      font-size: 15px;
                      font-family: Nunito Sans;
                      background-color: #419cff;
                      border-radius: 10px;
                      width: 10em;
                      font-weight: 660;
                    "
                    @click="signupDiv()"
                    >sign up</v-btn
                  >
                </div>
              </v-card>
            </div>
          </div>
        </show-at>
      </div>
    </show-at>
  </v-content>
</template>

<script>
//import { ModelViewerElement } from "@google/model-viewer/dist/model-viewer.js";

import { showAt, hideAt } from "vue-breakpoints";

import { mapState } from "vuex";

import axios from "axios";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

import { initFbsdk } from "@/config/facebook_auth.js";

export default {
  name: "mainLanding",
  components: { hideAt, showAt },
  data: function () {
    return {
      themeBackground: "",
      isActive: true,
      loginPopup: false,
      signUpPopup: false,
      localitem: [
        { icon: "/static/assets/svg/google.svg", provider: "google" },
        { icon: "/static/assets/svg/apples.svg", provider: "apple" },
        { icon: "/static/assets/svg/facebook.svg", provider: "facebook" },
      ],
      fileAsset: {
        filepng: "/static/assets/landingAsset/porscheCar.png",
        fileglb: "/static/assets/landingAsset/porscheCar.glb",
        fileusdz: "/static/assets/landingAsset/porscheCar.usdz",
        filehdr: "/static/assets/landingAsset/autoshop_01_1k.hdr",
        //filesound: "/static/assets/landingAsset/porscheCar.ogg",
        // fileee:
        //   "/static/assets/landingAsset/porscheCar.glb?sound=/static/assets/landingAsset/porscheCar.ogg",
        fileee: "/static/assets/landingAsset/porscheCar.glb",
      },
      // fileAsset: {
      //   filepng: "",
      //   fileglb: "",
      //   fileusdz: "",
      //   filehdr: "",
      //   filesound: "",
      //   fileee: "",
      // },
      errors: [],
      error: false,
      errorMsg: "",
      accountName: "",
      accountEmail: "",
      accountPassword: "",
      accountPasswordConfirm: "",
      showEye: false,
      passwordResetEmail: "",

      sign_up_div: false,
      log_in_div: false,

      quotation: "",
      author: "",
      quotes: [
        {
          quotation:
            "Good programmers use their brains, but good guidelines save us having to think out every case.",
          author: "Francis Glassborow",
        },
        {
          quotation:
            "Technology is anything that wasn’t around when you were born.",
          author: "Alan Kay",
        },
        {
          quotation:
            "Measuring programming progress by lines of code is like measuring aircraft building progress by weight.",
          author: "Bill Gates",
        },
        {
          quotation:
            "C makes it easy to shoot yourself in the foot; C++ makes it harder, but when you do it blows your whole leg off.",
          author: "Bjarne Stroustrup",
        },
        {
          quotation:
            "A brilliant solution to the wrong problem can be worse than no solution at all: solve the correct problem.",
          author: "Don Norman",
        },
        {
          quotation:
            "Walking on water and developing software from a specification are easy if both are frozen.",
          author: "Edward V. Berard",
        },
        {
          quotation:
            "Programs must be written for people to read, and only incidentally for machines to execute.",
          author: "Harold Abelson",
        },
        {
          quotation:
            "It doesn't matter what you know, what matters is when you know",
          author: "Kathy Sierra",
        },
        {
          quotation:
            "Perl – The only language that looks the same before and after RSA encryption.",
          author: "Keith Bostic",
        },
        {
          quotation:
            "One of my most productive days was throwing away 1000 lines of code.",
          author: "Ken Thompson",
        },
        {
          quotation:
            "Most of you are familiar with the virtues of a programmer. There are three, of course: laziness, impatience, and hubris.",
          author: "Larry Wall",
        },
        {
          quotation:
            "If we continue to develop our technology without wisdom or prudence, our servant may prove to be our executioner.",
          author: "Omar Bradley",
        },
        {
          quotation:
            "Great things in business are never done by one person. They're done by a team of people.",
          author: "Steve Jobs",
        },
        {
          quotation:
            "The real danger is not that computers will begin to think like men, but that men will begin to think like computers.",
          author: "Sydney Harris",
        },
        {
          quotation:
            "I don't care if it works on your machine! We are not shipping your machine!",
          author: "Vidiu Platon",
        },
        {
          quotation:
            "Programming isn't about what you know; it's about what you can figure out.",
          author: "Chris Pine",
        },
        {
          quotation:
            "Testing leads to failure, and failure leads to understanding.",
          author: "Burt Rutan",
        },
        {
          quotation:
            "A language that doesn't affect the way you think about programming is not worth knowing.",
          author: " Alan J. Perlis",
        },
        {
          quotation:
            "The best performance improvement is the transition from the nonworking state to the working state.",
          author: "J. Osterhout",
        },
        {
          quotation:
            "One man’s crappy software is another man’s full-time job. ",
          author: "Jessica Gaston",
        },
        {
          quotation:
            "All problems in computer science can be solved by another level of indirection.",
          author: "David Wheeler",
        },
        {
          quotation:
            "Any fool can write code that a computer can understand. Good programmers write code that humans can understand.",
          author: "Martin Fowler",
        },
        {
          quotation: "Code never lies; comments sometimes do.",
          author: "Ron Jeffries",
        },
        {
          quotation:
            "There are only two hard things in computer science: cache invalidation and naming things.",
          author: "Phil Karlton",
        },
        {
          quotation:
            "The question of whether computers can think is like the question of whether submarines can swim.",
          author: "Edsger W. Dijkstra",
        },
        {
          quotation: "Never trust a computer you can’t throw out a window.",
          author: "Steve Wozniak",
        },
        {
          quotation:
            "The Web is like a dominatrix.  Everywhere I turn, I see little buttons ordering me to Submit.",
          author: "Nytwind",
        },
        {
          quotation:
            "Controlling complexity is the essence of computer programming.",
          author: "Brian Kernigan",
        },
        {
          quotation:
            "There are only two industries that refer to their customers as ‘users’.",
          author: "Edward Tufte",
        },
        {
          quotation:
            "Fifty years of programming language research, and we end up with C++?",
          author: "Richard A. O’Keefe",
        },
        {
          quotation:
            "It is not about bits, bytes and protocols, but profits, losses and margins.",
          author: "Lou Gerstner",
        },
        {
          quotation:
            "Optimism is an occupational hazard of programming; feedback is the treatment.",
          author: "Kent Beck",
        },
        {
          quotation:
            "You can’t have great software without a great team, and most software teams behave like dysfunctional families.",
          author: "Jim McCarthy",
        },
        {
          quotation: "I think there’s a world market for about 5 computers.",
          author: "Thomas J. Watson",
        },
        {
          quotation:
            "If it keeps up, man will atrophy all his limbs but the push-button finger.",
          author: "Frank Lloyd Wrigh",
        },
      ],
      rules: {
        required: (value) => !!value || "Required.",
        minPass: (v) => v.length >= 8 || "Min 8 characters",
        maxPass: (v) => v.length <= 30 || "Max 30 characters",
        minName: (v) => v.length >= 3 || "Min 3 characters",
        maxName: (v) => v.length <= 30 || "Max 30 characters",
        emailMatch: () => "The email and password you entered don't match",
        email: (value) => {
          if (value.length > 0) {
            const pattern =
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "Invalid e-mail.";
          }
        },
      },
    };
  },
  //mounted
  mounted() {
    initFbsdk();

    //for theme
    this.isActive = this.augmentableTheme;
    this.themeBackground = this.$vuetify.theme.themes[this.theme].background;
    //vuetify-theme-themes[theme]-background

    //for automatic quote
    let num = Math.floor(Math.random() * this.quotes.length);
    this.quotation = this.quotes[num].quotation;
    this.author = this.quotes[num].author;

    // let viewer = new ModelViewerElement();
    // viewer = document.getElementById("loading-demo-sub");
    // viewer.addEventListener("load", () => {
    //   var sound = document.getElementById("sound");
    //   sound.play();
    // });
  },
  //watch
  // watch:{

  // },
  //computed
  computed: {
    ...mapState(["augmentableTheme"]),
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },

  //methods
  methods: {
    changetheme() {
      this.isActive = !this.isActive;

      if (this.isActive === false) {
        this.$store.commit("setAugmentableTheme", false);
        this.$vuetify.theme.dark = false;
        this.themeBackground =
          this.$vuetify.theme.themes[this.theme].background;
      } else if (this.isActive === true) {
        this.$store.commit("setAugmentableTheme", true);
        this.$vuetify.theme.dark = true;
        this.themeBackground =
          this.$vuetify.theme.themes[this.theme].background;
      }
    },
    signupPopupDiv() {
      this.signUpPopup = true;
      this.sign_up_div = true;
      this.loginPopup = false;
      this.log_in_div = false;
    },
    loginPopupDiv() {
      this.loginPopup = true;
      this.log_in_div = true;
      this.signUpPopup = false;
      this.sign_up_div = false;
    },
    signupDiv() {
      if (this.sign_up_div === true) {
        this.checkFormSignUp();
      } else {
        if (this.$refs["form"]) {
          this.$refs.form.resetValidation();
        }

        this.accountName = "";
        this.accountEmail = "";
        this.accountPassword = "";
        this.accountPasswordConfirm = "";

        this.log_in_div = false;
        this.sign_up_div = true;
        this.empty_div = false;

        this.sub_title = "signup here";
        this.sub_title_1 = "signup";
        this.sub_title_2 = "here";

        this.error = false;

        this.flashScr1 = true;
      }
    },
    loginDiv() {
      if (this.log_in_div === true) {
        this.checkFormLogIn();
      } else {
        if (this.$refs["form"]) {
          this.$refs.form.resetValidation();
        }
        this.accountName = "";
        this.accountEmail = "";
        this.accountPassword = "";
        this.accountPasswordConfirm = "";

        this.sign_up_div = false;
        this.log_in_div = true;
        this.empty_div = false;

        this.sub_title = "you're back";
        this.sub_title_1 = "you're";
        this.sub_title_2 = "back";

        this.error = false;

        this.flashScr1 = true;
      }
    },
    checkFormSignUp() {
      this.errors = [];

      if (!this.accountName) {
        this.errors.push("Name required.");
        this.error = true;
        this.errorMsg = "*All fileds are required!";
        return;
      }
      if (!this.accountEmail) {
        this.errors.push("Email required.");
        this.error = true;
        this.errorMsg = "*All fileds are required!";
        return;
      }
      if (!this.accountPassword) {
        this.errors.push("Password required.");
        this.error = true;
        this.errorMsg = "*All fileds are required!";
        return;
      }
      if (!this.accountPasswordConfirm) {
        this.errors.push("Password required.");
        this.error = true;
        this.errorMsg = "*All fileds are required!";
        return;
      }
      if (this.accountPassword != this.accountPasswordConfirm) {
        this.errors.push("Password mismatch.");
        this.error = true;
        this.errorMsg = "*Passwords are not matching";
        return;
      }

      if (this.errors.length > 0) {
        return;
      } else {
        this.error = true;
        this.errorMsg = "Contact at 'info@weltfern.com'";

        // let formData = new FormData();
        // formData.append("username", this.accountName);
        // formData.append("email", this.accountEmail);
        // formData.append("password1", this.accountPassword);
        // formData.append("password2", this.accountPasswordConfirm);
        // //formData.append("password", this.accountPassword);

        // // /dj-rest-auth/registration/
        // axios
        //   .post("/dj-rest-auth/registration/", formData, {
        //     headers: {
        //       "Content-Type": "multipart/form-data",
        //     },
        //   })
        //   .then((response) => {
        //     //console.log(response.data);
        //     //var size = Object.keys(response.data).length;

        //     //console.log(response);
        //     //console.log(response.data);
        //     //console.log(response.data.username);
        //     //console.log(response.data.key);
        //     //console.log(response.data.email[0]);
        //     //console.log(size);

        //     document.cookie = "augmentableUserToken=" + response.data.key + "";

        //     this.loginDiv();
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //     this.error = true;
        //     this.errorMsg = "Try other username or email";
        //   });
      }
    },
    checkFormLogIn() {
      this.errors = [];

      if (!this.accountName) {
        this.errors.push("Name required.");
        this.error = true;
        this.errorMsg = "*All fileds are required!";
        return;
      }
      if (!this.accountEmail) {
        this.errors.push("Email required.");
        this.error = true;
        this.errorMsg = "*All fileds are required!";
        return;
      }
      if (!this.accountPassword) {
        this.errors.push("Password required.");
        this.error = true;
        this.errorMsg = "*All fileds are required!";
        return;
      }

      if (this.errors.length > 0) {
        return;
      } else {
        //console.log("success");

        let formData = new FormData();

        //formData.append("username", this.accountEmail); //django username as email on login
        formData.append("username", this.accountName);
        formData.append("email", this.accountEmail);
        formData.append("password", this.accountPassword);

        axios
          .post(this.$abServerPath + "/dj-rest-auth/login/", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            console.log(response.data);
            console.log("gggg");
            console.log(response.data.access_token);
            document.cookie = "augmentableUserToken=" + response.data.key + "";
            //document.cookie = "augmentableUserToken=" + response.data.key + "";
            axios
              .get(this.$abServerPath + "/dj-rest-auth/user/", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Token " + response.data.key + "",
                },
              })
              .then((response) => {
                var tt = response.data.pk;
                axios
                  .get(
                    this.$abServerPath + "/api/users1/userInfooID/" + tt + "/"
                  )
                  .then((response) => {
                    this.$store.commit("setUserType", response.data.user_type);
                  })
                  .catch((error) => {
                    console.log(error);
                  });

                this.$store.commit("setAuthentication", true); //store info in vuex store //here key can be used
                this.$store.commit("setFileDetail", "");
                //this.$router.replace({ name: "viewer" });
                if (response.data.username === "adidas") {
                  this.$router.push({ path: "./assets" });
                } else {
                  this.$router.push({ path: "./viewer" });
                }

                console.log(response);
                return;

                //console.log(response.data);
              })
              .catch((error) => {
                //console.log("user information22");
                console.log(error);
                //console.log(response.data);
              });
          })
          .catch((error) => {
            this.error = true;
            //this.errorMsg = "Authentication Problem!";
            // this.errorMsg = error.response.data.detail;
            //console.log("sfjhgfj");
            //console.log(error.response.data.detail);
            //console.log(error.response.data.detail);

            if (error.response.status === 400) {
              this.errorMsg = "Authentication Problem!";
            } else if (
              error.response.status === 401 &&
              error.response.statusText === "Unauthorized"
            ) {
              this.errorMsg = error.response.data.detail;
              this.sendPasswordResetLink(this.accountEmail);
              // auth.logout();
              // thirouter.replace('/');
            }
            //return Promise.reject(error.response);
            // console.log(response);
            // return;
          });
      }
    },
    sendPasswordResetLink(email) {
      let formData12 = new FormData();
      formData12.append("email", email);

      axios
        .post("/dj-rest-auth/password/reset/", formData12, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sendPasswordResetLinkEmail(email) {
      let formData12 = new FormData();
      formData12.append("email", email);

      axios
        .post("/dj-rest-auth/password/reset/", formData12, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.detail) {
            alert(response.data.detail);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    validateEmail(email) {
      if (email.length > 0) {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(email) || "Invalid e-mail.";
      } else {
        return "Invalid e-mail.";
      }
    },
    sendPasswordResetEmail() {
      if (this.accountEmail) {
        let checkedEmail = this.validateEmail(this.accountEmail);
        if (checkedEmail === true) {
          let formData12 = new FormData();
          formData12.append("email", this.accountEmail);

          axios
            .post("/dj-rest-auth/password/reset/", formData12, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              if (response.data.detail) {
                alert(response.data.detail);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          alert("Invalid Email");
        }
      } else {
        alert("you should enter your 'Email' in the email field.");
      }
    },
    loginWithGoogle() {
      this.$gAuth
        .signIn()
        .then((GoogleUser) => {
          // on success do something
          console.log("GoogleUser", GoogleUser);
          console.log("getId", GoogleUser.getId());
          console.log("basicprofile", GoogleUser.getBasicProfile().getName());
          console.log("getBasicProfile", GoogleUser.getBasicProfile());
          console.log("getAuthResponse", GoogleUser.getAuthResponse());
          var userInfo = {
            loginType: "google",
            google: {
              auth: GoogleUser.getAuthResponse(),
              user: {
                name: GoogleUser.getBasicProfile().getName(),
                email: GoogleUser.getBasicProfile().getEmail(),
                profileImage: GoogleUser.getBasicProfile().getImageUrl(),
              },
            },
          };
          console.log(userInfo);
          //this.$store.commit('setLoginUser', userInfo)
          //router.push('/home')
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    loginWithFacebook() {
      window.FB.login((response) => {
        if (response && response.authResponse) {
          console.log("response", response);
          var userInfo = {
            loginType: "fb",
            fb: {
              auth: response.authResponse,
            },
          };
          console.log(userInfo);
          console.log("fff");
          //this.$store.commit("setLoginUser", userInfo);
          window.FB.api(
            `/${response.authResponse.userID}`,
            (userResponse) => {
              if (userResponse) {
                console.log(userResponse);
                var userInfo = {
                  loginType: "fb",
                  fb: {
                    auth: response.authResponse,
                    user: userResponse,
                  },
                };
                console.log(userInfo);
                //this.$store.commit("setLoginUser", userInfo);
              }
            },
            this.params
          );
          // window.FB.getLoginStatus(function (response) {
          //   statusChangeCallback(response);
          // });
          //window.FB.logout();
          // window.FB.logout(function (response) {
          //   // user is now logged out
          //   console.log(response);
          // });
          //router.push("/home");
        }
      }, this.params);
    },
    socialSignup(item) {
      console.log(item.provider);
      if (item.provider === "google") {
        this.loginWithGoogle();
      } else if (item.provider === "facebook") {
        initFbsdk();
        this.loginWithFacebook();
      }
    },
    goToWeltfernSite() {
      window.open("https://www.weltfern.com/augmentable", "_blank");
    },
    getAuthCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Raleway:200,300,400,600,700,800,900");
@import url("https://fonts.googleapis.com/css?family=Nunito Sans:200,300,400,600,700,800,900");

.progress-bar {
  display: block;
  width: 33%;
  height: 10%;
  max-height: 2%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  border-radius: 25px;
  box-shadow: 0px 3px 10px 3px rgba(0, 0, 0, 0.5),
    0px 0px 5px 1px rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.9);
}

.progress-bar.hide {
  visibility: hidden;
  transition: visibility 0.3s;
}

.update-bar {
  background-color: rgba(255, 255, 255, 0.9);
  width: 0%;
  height: 100%;
  border-radius: 25px;
  float: left;
  transition: width 0.3s;
}

.landingContainerL {
  background-color: #262626;
}
.landingContainerLC {
  background-color: #ededed;
}
.landingContainerR {
  background-image: radial-gradient(#808080, #262626);
}
.landingContainerRC {
  background-image: radial-gradient(#e6e6e6, #cccccc);
}
.textureL {
  color: #cfcfcf;
}
.textureLC {
  color: #323232;
}
.overlayContainer {
  position: absolute;
  width: 100%;
  height: 100%;
  display: block;
  overflow-y: hidden;
  top: 0;
  left: 0;
  background-color: rgba(black, 0.5);
  z-index: 90000;
}
.overlayElement {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.signup_button {
  background-color: #419cff;
}
.signup_button:hover {
  transform: scale(1.1);
  -moz-box-shadow: 0 0 10px #ccc;
  -webkit-box-shadow: 0 0 10px #ccc;
  box-shadow: 0 0 10px #ccc;
}
.login_button {
  background-color: white;
}
.login_button:hover {
  transform: scale(1.1);
  -moz-box-shadow: 0 0 10px #ccc;
  -webkit-box-shadow: 0 0 10px #ccc;
  box-shadow: 0 0 10px #ccc;
}
.my-menu-signupL {
  margin-top: 18px;
  contain: initial;
  overflow: visible;
}
.my-menu-signupL::before {
  position: absolute;
  content: "";
  top: 0;
  left: 110px;
  transform: translateY(-100%);
  width: 10px;
  height: 13px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid #ededed;
}
.my-menu-signupD {
  margin-top: 18px;
  contain: initial;
  overflow: visible;
}
.my-menu-signupD::before {
  position: absolute;
  content: "";
  top: 0;
  left: 110px;
  transform: translateY(-100%);
  width: 10px;
  height: 13px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid #303030;
}
.tablet-loginL {
  margin-top: 18px;
  contain: initial;
  overflow: visible;
}
.tablet-loginL::before {
  position: absolute;
  content: "";
  top: 0;
  left: 150px;
  transform: translateY(-100%);
  width: 10px;
  height: 13px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid #ededed;
}
.tablet-loginD {
  margin-top: 18px;
  contain: initial;
  overflow: visible;
}
.tablet-loginD::before {
  position: absolute;
  content: "";
  top: 0;
  left: 150px;
  transform: translateY(-100%);
  width: 10px;
  height: 13px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid #303030;
}
.tablet-signupL {
  margin-top: 12px;
  contain: initial;
  overflow: visible;
}
.tablet-signupL::before {
  position: absolute;
  content: "";
  top: 0;
  right: 150px;
  transform: translateY(-100%);
  width: 10px;
  height: 13px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid #ededed;
}
.tablet-signupD {
  margin-top: 12px;
  contain: initial;
  overflow: visible;
}
.tablet-signupD::before {
  position: absolute;
  content: "";
  top: 0;
  right: 150px;
  transform: translateY(-100%);
  width: 10px;
  height: 13px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid #303030;
}
.menu-small-signup {
  margin-top: 3px;
  contain: initial;
  overflow: visible;
}

.my-menu-loginL {
  margin-top: 58px;
  contain: initial;
  overflow: visible;
}
.my-menu-loginL::before {
  position: absolute;
  content: "";
  top: 0;
  right: 110px;
  transform: translateY(-100%);
  width: 10px;
  height: 13px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid #ededed;
}

.my-menu-loginD {
  margin-top: 58px;
  contain: initial;
  overflow: visible;
}
.my-menu-loginD::before {
  position: absolute;
  content: "";
  top: 0;
  right: 110px;
  transform: translateY(-100%);
  width: 10px;
  height: 13px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid #303030;
}

model-viewer#loading-demo-sub {
  --poster-color: transparent;
}
</style>
